import { getLocationBreadcrumbArray } from '@pkgs/api';

import { isIndexedExpose } from '@/utils/propertyDataUtils';
import { useSettings } from '@/hooks/useSettings';
import { useExposePageProps } from '@/hooks/useExposePageProps';
import { useListing } from '@/hooks/queries/useListing';

import { Breadcrumb } from '../Breadcrumb';

// these are on the exposee page
export const LocationBreadcrumb = () => {
  const {
    data: { listing, genericListing },
  } = useListing();
  const { countryCode, language } = useSettings();
  const { pageVariant, pageLanguages } = useExposePageProps();
  // it's already checked on parent component whether addressComponents is defined

  const items = getLocationBreadcrumbArray({ listing: genericListing, shouldIncludeUrls: true });
  const isIndexed = isIndexedExpose({
    listing,
    pageVariant,
    countryCode,
    language,
    pageLanguages,
  });

  return <Breadcrumb items={items} isIndexed={isIndexed} data-testid="expose-location-breadcrumb" />;
};
